import { eventRowThumb } from '../assets/index'
import youthSummitHero from '../assets/images/events/youth-summit-hero.jpg'
import activityWorkshops from '../assets/icons/events/activity-workshops.png'
import activityExpertSessions from '../assets/icons/events/activity-expert-sessions.png'
import activityTeamBuilding from '../assets/icons/events/activity-team-building.png'
import activityCertification from '../assets/icons/events/activity-certification.png'

export const eventFilters = [
  { id: 'all', label: 'All Events' },
  { id: 'leadership', label: 'Leadership' },
  { id: 'cultural', label: 'Cultural' },
  { id: 'social-women', label: 'Social & Women' },
  { id: 'community', label: 'Community' },
]

const youthSummitActivities = [
  {
    title: 'Interactive Workshops',
    description:
      'Hands-on sessions to develop leadership, communication, and decision-making skills.',
    icon: activityWorkshops,
    iconBgColor: 'rgba(183,7,7,0.12)',
  },
  {
    title: 'Expert Sessions',
    description:
      'Inspiring talks from successful leaders, entrepreneurs, and social change makers',
    icon: activityExpertSessions,
    iconBgColor: 'rgba(183,142,7,0.12)',
  },
  {
    title: 'Team Building Activities',
    description: 'Team activities that build collaboration, trust, and leadership skills.',
    icon: activityTeamBuilding,
    iconBgColor: 'rgba(115,183,7,0.12)',
  },
  {
    title: 'Certification & Recognition',
    description:
      'Official certificate of completion and recognition for outstanding participants',
    icon: activityCertification,
    iconBgColor: 'rgba(7,183,183,0.12)',
  },
]

const baseEvents = [
  {
    dayName: 'Mon',
    dayNumber: '25',
    monthYear: 'May 2026',
    title: 'Youth Leadership Summit',
    description:
      'A dynamic gathering of young minds focused on leadership, personal growth, and nation-building through inspiring sessions, mentorship, and meaningful discussions.',
    slug: 'youth-leadership-summit',
    image: eventRowThumb,
    category: 'leadership',
    detailDate: 'May 26, 2026',
    heroImage: youthSummitHero,
    intro:
      'The Youth Leadership Summit is an inspiring event designed to empower young individuals with leadership skills, confidence, discipline, and a vision for nation-building. Through interactive sessions, mentorship, workshops, and team activities, participants will gain practical knowledge and personal growth experiences that prepare them for future challenges and opportunities.',
    highlights: [
      'Leadership Development Sessions',
      'Interactive Team Activities',
      'Communication & Public Speaking Workshops',
      'Motivational & Mentorship Sessions',
      'Networking With Young Leaders',
      'Community & Nation-Building Discussions',
      'Personal Growth & Confidence Building',
    ],
    participants: [
      'College & University Students',
      'Young Professionals',
      'Aspiring Leaders & Volunteers',
      'Youth Interested In Social Impact & Leadership',
    ],
    learningOutcomes: [
      'Build leadership and decision-making skills',
      'Improve communication and teamwork',
      'Develop confidence and discipline',
      'Learn the importance of service and civic responsibility',
      'Gain practical leadership experience through activities',
    ],
    activities: youthSummitActivities,
    whyAttend:
      'The summit provides a platform for youth to learn, connect, grow, and become future-ready leaders capable of driving positive change in society.',
  },
  {
    dayName: 'Mon',
    dayNumber: '25',
    monthYear: 'May 2026',
    title: 'Voices Of Change',
    description:
      'An inspiring platform where young voices come together to share ideas, create impact, and drive positive change through leadership and meaningful action.',
    slug: 'voices-of-change',
    image: eventRowThumb,
    category: 'leadership',
    detailDate: 'May 18, 2026',
    heroImage: eventRowThumb,
    intro:
      'Voices Of Change is a dynamic platform that brings together young changemakers to share ideas, collaborate on solutions, and inspire meaningful action. Through panel discussions, storytelling sessions, and interactive forums, participants explore how youth can drive social transformation.',
    highlights: [
      'Youth Panel Discussions',
      'Storytelling & Idea Sharing Sessions',
      'Community Impact Workshops',
      'Leadership Dialogue Forums',
      'Networking With Changemakers',
      'Action Planning Sessions',
    ],
    participants: [
      'College & University Students',
      'Young Activists & Volunteers',
      'Aspiring Social Entrepreneurs',
      'Youth Passionate About Community Change',
    ],
    learningOutcomes: [
      'Develop public speaking and advocacy skills',
      'Learn collaborative problem-solving approaches',
      'Understand community engagement strategies',
      'Build networks with like-minded youth leaders',
      'Create actionable plans for social impact',
    ],
    activities: youthSummitActivities,
    whyAttend:
      'This event empowers young voices to be heard, connect with peers who share their passion for change, and gain practical tools to make a difference in their communities.',
  },
  {
    dayName: 'Mon',
    dayNumber: '25',
    monthYear: 'May 2026',
    title: 'Journey To Leadership',
    description:
      'A transformative journey designed to develop confidence, leadership skills, discipline, and purpose among youth through learning, mentorship, and real-world experiences.',
    slug: 'journey-to-leadership',
    image: eventRowThumb,
    category: 'leadership',
    detailDate: 'May 10, 2026',
    heroImage: eventRowThumb,
    intro:
      'Journey To Leadership is a transformative program that guides youth through a structured path of personal and leadership development. Combining mentorship, experiential learning, and reflective sessions, this event helps participants discover their purpose and build the skills needed to lead with confidence.',
    highlights: [
      'Personal Leadership Assessment',
      'Mentorship Circles',
      'Goal Setting & Vision Workshops',
      'Discipline & Self-Management Training',
      'Real-World Leadership Challenges',
      'Reflection & Growth Sessions',
    ],
    participants: [
      'High School & College Students',
      'Young Professionals Starting Their Careers',
      'Youth Seeking Personal Development',
      'Emerging Community Leaders',
    ],
    learningOutcomes: [
      'Discover personal leadership strengths',
      'Set clear goals and develop action plans',
      'Build self-discipline and accountability',
      'Gain mentorship and guidance from experienced leaders',
      'Develop confidence to take on leadership roles',
    ],
    activities: youthSummitActivities,
    whyAttend:
      'This journey provides a supportive environment for youth to explore their leadership potential, receive mentorship, and take meaningful steps toward becoming confident, purpose-driven leaders.',
  },
]

export const eventsPageUpcoming = baseEvents

export const eventsPageAll = baseEvents

export function getEventBySlug(slug) {
  return baseEvents.find((event) => event.slug === slug)
}

export function getRelatedEvents(currentSlug, limit = 2) {
  return baseEvents.filter((event) => event.slug !== currentSlug).slice(0, limit)
}

export function filterEventsByCategory(events, filterId) {
  if (filterId === 'all') return events
  return events.filter((event) => event.category === filterId)
}
